import { Grid2, styled } from "@mui/material";
import { linearProgressClasses } from "@mui/material/LinearProgress";

const PREFIX = "progress";
export const classes = {
  questionColumn: `${PREFIX}-questionColumn`,
  progressHeader: `${PREFIX}-progressHeader`,
  progressBar: `${PREFIX}-progressBar`,
  progressRow: `${PREFIX}-progressRow`,
  restartButton: `${PREFIX}-restartButton`,
};

export const ProgressGrid = styled(Grid2)(({ theme }) => ({
  backgroundColor: theme.palette.background.level1,
  justifyContent: "space-evenly",
  paddingLeft: 20,
  paddingRight: 20,
  marginBottom: 20,
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  paddingTop: 10,
  paddingBottom: 10,
  border: "1px solid rgb(0 0 0 / 10%)",
  borderRadius: "8px",
  "@media(max-width: 600px)": {
    padding: "10px",
  },
  [`& .${classes.questionColumn}`]: {
    alignItems: "center",
    fontWeight: "bold",
    justifyContent: "center",
    textAlign: "center",
  },
  [`& .${classes.progressHeader}`]: {
    display: "flex",
    marginBottom: 3,
    justifyContent: "center",
    fontWeight: "normal",
    "@media(max-width: 600px)": {
      justifyContent: "flex-start",
      fontSize: "18px",
      fontWeight: 500,
    },
  },
  [`& .${classes.progressBar}`]: {
    display: "flex",
    justifyContent: "center",
    height: 20,
    width: "100%",
    borderRadius: 5,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
  [`& .${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.white.main,
  },
  [`& .${classes.restartButton}`]: {
    "& .MuiButton-root": {
      backgroundColor: theme.palette.white.main,
      color: theme.palette.primary.main,
    },
    "@media(max-width: 600px)": {
      justifyContent: "flex-end",
    },
  },
}));
